import { generatePath } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import queryString from 'query-string'

import { SentryErrorType } from 'Constants/errors'

import type { ComposePath } from './composePath.types'

/**
 * Wrapper for generatePath to compose organisation, employee or public path
 */
export const composePath: ComposePath = (
  { path, paths, isOrganisation, params },
  qString,
  basePath = '',
  options = {},
) => {
  const preparedPath =
    path ?? (isOrganisation ? paths.organisation : paths.employee)

  const pathToGenerate = basePath + preparedPath

  const { skipSentry } = options

  try {
    const stringParams = Object.fromEntries(
      Object.entries(params).map(([k, v]) => [
        k,
        v === null || v === undefined ? v : String(v),
      ]),
    )
    const generatedPath = generatePath(pathToGenerate, stringParams)

    return qString
      ? `${generatedPath}?${queryString.stringify(qString)}`
      : generatedPath
  } catch (error) {
    if (!skipSentry) {
      Sentry.captureException(error, {
        extra: {
          isOrganisation,
          params,
          path,
          paths,
          type: SentryErrorType.COMPOSE_PATH_ERROR,
        },
      })
    }

    return ''
  }
}
